<template>
	<a class="skip-to-content u-link">
		{{ $t('global-skip-to-content') }}
	</a>
</template>

<style scoped>
.skip-to-content {
	background: var(--c-white);
	border: var(--size-1) solid var(--c-grey-400);
	border-radius: var(--border-radius-md);
	box-shadow: var(--u-popover-shadow);
	font: var(--type-body-m-bold);
	inset-block-start: calc(var(--header-block-size) / 2);
	justify-self: center;
	padding-block: var(--size-8);
	padding-inline: var(--size-12);
	position: fixed;
	translate: 0 -50%;
	z-index: var(--z-index-skip-to-content);

	&:not(:focus-visible, :active) {
		inset-block-start: -4rem;
	}
}
</style>
